(function () {

    angular.module('FotocApp')

        .factory('$lang', function () {

            return LANG;
        
        })
    
})();